import React from 'react';
import { Grid, Paper, Typography, Box, Skeleton, Chip } from '@mui/material';
import { MdLoop, MdCheckCircle, MdEmail, MdHistory } from 'react-icons/md';

export default function CycleStatsCards({ cycles, loading }) {
  const rows = cycles ?? [];

  const openCycle = rows.find((c) => !c.completedAt);
  const completedCycles = rows.filter((c) => !!c.completedAt);
  const lastCompleted = completedCycles[0] ?? null;
  const totalEmailsSent = rows.reduce((s, c) => s + (c.totalEmailsSent ?? 0), 0);

  const cards = [
    {
      label: 'Cycle en cours',
      icon: <MdLoop size={28} />,
      color: '#38A169',
      bgColor: '#F0FFF4',
      value: openCycle ? `#${openCycle.cycleNumber}` : '—',
      sub: openCycle
        ? `${openCycle.totalEnterprisesProcessed} entreprises traitées`
        : 'Aucun cycle actif',
      badge: openCycle ? <Chip label="En cours" color="success" size="small" /> : null,
    },
    {
      label: 'Dernier cycle terminé',
      icon: <MdCheckCircle size={28} />,
      color: '#3182CE',
      bgColor: '#EBF8FF',
      value: lastCompleted ? `#${lastCompleted.cycleNumber}` : '—',
      sub: lastCompleted
        ? new Date(lastCompleted.completedAt).toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          })
        : 'Aucun cycle terminé',
      badge: null,
    },
    {
      label: 'Total emails envoyés',
      icon: <MdEmail size={28} />,
      color: '#805AD5',
      bgColor: '#FAF5FF',
      value: totalEmailsSent,
      sub: 'Tous cycles confondus',
      badge: null,
    },
    {
      label: 'Cycles complétés',
      icon: <MdHistory size={28} />,
      color: '#DD6B20',
      bgColor: '#FFFAF0',
      value: completedCycles.length,
      sub: `${rows.length} cycles au total`,
      badge: null,
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={3} key={card.label}>
          <Paper
            elevation={2}
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              borderLeft: `4px solid ${card.color}`,
            }}
          >
            <Box
              sx={{
                p: 1,
                borderRadius: 2,
                backgroundColor: card.bgColor,
                color: card.color,
                display: 'flex',
                flexShrink: 0,
              }}
            >
              {card.icon}
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="caption" color="text.secondary">
                {card.label}
              </Typography>
              {loading ? (
                <Skeleton width={60} height={32} />
              ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="h5" fontWeight="bold" color={card.color}>
                    {card.value}
                  </Typography>
                  {card.badge}
                </Box>
              )}
              <Typography variant="caption" color="text.secondary" noWrap>
                {card.sub}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}
